/**
 * JSBridge 通信工具 (适配xlanhao直接调用版)
 */
export default class JSBridge {
  constructor() {
    this.callbacks = {};
    this.isAndroid = !!window.xlanhao;
    this._setupCallback();
  }

  /**
   * 调用原生方法（终极简化版）
   * @param {string} method 方法名（必须和安卓完全一致）
   * @param {object} params 参数
   * @param {function} [callback] 可选回调
   */
  call(method, params = {}, callback) {
    console.log(window.xlanhao, 'window.xlanhao>>>>>>>>>>>')
    return new Promise((resolve, reject) => {
      if (!this.isAndroid) {
        const err = new Error('非Android环境');
        callback?.(err);
        reject(err);
        return;
      }

      const callbackId = 'cb_' + Date.now();
      
      // 存储回调
      this.callbacks[callbackId] = (result) => {
        callback?.(result);
        resolve(result);
      };

      try {
        // 直接调用（不再检查方法是否存在）
        window.xlanhao[method](JSON.stringify({
          ...params,
          _callbackId: callbackId  // 必须包含回调ID
        }));
      } catch (e) {
        delete this.callbacks[callbackId];
        console.error(`[JSBridge] 调用 ${method} 失败:`, e);
        callback?.({ error: e.message });
        reject(e);
      }
    });
  }

  // 私有方法：设置全局回调
  _setupCallback() {
    window.JSBridgeCallback = (res) => {
      try {
        const data = typeof res === 'string' ? JSON.parse(res) : res;
        if (data.callbackId && this.callbacks[data.callbackId]) {
          this.callbacks[data.callbackId](data.response);
          delete this.callbacks[data.callbackId];
        }
      } catch (e) {
        console.error('[JSBridge] 回调处理失败:', e);
      }
    };
  }
}